import React from "react";

const Features = ({ data }) => {
  return (
    <div className=" wow zoomIn">
      {/* <h4>{title}</h4> */}
      <p dangerouslySetInnerHTML={{ __html: data }}></p>
    </div>
  );
};

export default Features;
